// Body for the Oscar account order-detail document: the account side-nav shell
// and content title wrapping the shared OrderDetail `.order-summary` block. The
// OrderDetail component is factory-made per-site (createOrderDetail injects the
// brand's OrderOffer), so it is passed in rather than imported here, keeping
// this shell site-free.
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { AccountContentTitle } from "../AccountContentTitle";
import { SideNav } from "../SideNav";

type IData = Immutable<
    NonNullable<templates.OrderDetailDocumentTemplate["order_detail"]>
>;

type IProps = Immutable<templates.OrderDetailDocumentTemplate> & {
    OrderDetail: React.ComponentType<Immutable<{ data: IData }>>;
};

export const OrderDetailBody = (props: IProps): React.JSX.Element => {
    const {
        has_nav,
        side_nav,
        content_title,
        phone_display,
        phone_href,
        order_detail,
        OrderDetail,
    } = props;
    return (
        <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
            {has_nav && (
                <div className="l-side-nav">
                    <SideNav items={side_nav} />
                </div>
            )}

            <div className="l-side-nav-content">
                <AccountContentTitle
                    contentTitle={content_title}
                    phoneDisplay={phone_display}
                    phoneHref={phone_href}
                />

                <div className="content__copy--full-width">
                    <div>
                        {/* Nullable only for the rich-shape sites, which render
                            their own wrapper instead of this body; always
                            populated wherever this body renders. */}
                        {order_detail && <OrderDetail data={order_detail} />}
                    </div>
                </div>
            </div>
        </div>
    );
};
